<template>
  <div>
    <a-card title="员工账号" class="card">
      <a-row gutter="16">
        <a-col :span="24" :md="8" :xl="6" style="margin-bottom: 12px">
          <a-input-search v-model="searchForm.search" placeholder="员工姓名" allowClear @search="search" />
        </a-col>

        <div style="margin-bottom: 12px; float: right">
          <a-button type="primary" icon="plus" style="margin: 0 8px" @click="
              targetItem = { ...form };
              visible = true;
            ">
            新增账号</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table rowKey="id" size="small" :columns="columns" :dataSource="items" :loading="loading"
          :pagination="pagination" @change="tableChange">
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? '#32CD99' : '#856363'">{{value ? '启用' : '禁用'}}</a-tag>
          </div>
          <div slot="is_admin" slot-scope="value">
            <a-tag :color="value ? '#32CD99' : '#856363'">{{value ? '是' : '否'}}</a-tag>
          </div>
          <div slot="role_names" slot-scope="value, item">
            <a-tag v-for="roleItem in item.role_items" :key="roleItem.id" color="#2db7f5">
              {{ roleItem.name }}
            </a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="edit" size="small" @click="
                  targetItem = { ...item };
                  visible = true;
                ">编辑</a-button>
              <a-popconfirm title="重置密码为：123456" @confirm="resetPassword(item.id)">
                <a-button size="small" type="primary" icon="sync">重置密码</a-button>
              </a-popconfirm>
              <a-popconfirm title="确定删除吗?" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
          <!-- <div slot="expandedRowRender" slot-scope="item">
            <div style="font-weight: bold; font-size: 15px;">拥有权限:</div>
            <a-row>
              <a-col v-for="key in item.permissions" :key="key" :span="4">{{permissions[key]}}</a-col>
            </a-row>
          </div> -->
        </a-table>
      </a-row>
    </a-card>

    <form-modal v-model="visible" :form="targetItem" :roleItems="roleItems" @create="create" @update="update" />
  </div>
</template>

<script>
import { userList, userDestroy, userResetPassword } from "@/api/account";
import { roleOption } from "@/api/option";
//import { permissions } from "@/permissions.js";
import columns from "./columns.js";

export default {
  name: "Account",
  components: {
    FormModal: () => import("./FormModal.vue"),
  },
  data () {
    return {
      columns,
      //permissions,
      searchForm: { search: "", page: 1, ordering: undefined, page_size: 12 },
      pagination: { current: 1, total: 0, pageSize: 12 },
      loading: false,
      items: [],
      roleItems: [],
      visible: false,
      targetItem: {},
      form: {},
    };
  },
  methods: {
    initialize () {
      this.list();

      roleOption({ page_size: 1000000 }).then((data) => {
        this.roleItems = data.results;
      });
    },
    list () {
      this.loading = true;
      userList(this.searchForm)
        .then((data) => {
          if (data.code==0){
          this.pagination.total = data.total;
          this.items = data.results;
          }else{
            this.$message.error(data.msg);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create (item) {
      // this.items.splice(0, 0, item);
      this.list();
    },
    update (item) {
      this.items.splice(
        this.items.findIndex((i) => i.id == item.id),
        1,
        item
      );
    },
    destroy (id) {
      userDestroy({ id }).then((data) => {
        // this.items.splice(this.items.findIndex(item => item.id == id), 1);
        if (data.code==0){
        this.$message.success("删除成功");
        this.list();}else{
            this.$message.error(data.msg);
            };
      });
    },
    resetPassword (id) {
      userResetPassword({ id }).then((data) => {
        if (data.code==0){
        this.$message.success("重置成功")}else{
            this.$message.error(data.msg);
          };
      });
    },
    search () {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    tableChange (pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      this.list();
    },
    openFormModal (item) {
      this.targetItem = { ...item };
      this.visible = true;
    },
  },
  mounted () {
    this.initialize();
  },
};
</script>

<style scoped>
.card {
  border-radius: 8px;
}
</style>
